import NoAdvisorAssistanceContainer from './NoAdvisorAssistanceContainer';

export default NoAdvisorAssistanceContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/SpeakToAdvisorPage/NoAdvisorAssistance/index.js